import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const ButtonContainer = styled.button`
  ${tw`flex items-center justify-center gap-1 font-semibold text-button-blue leading-6`}
`;
